import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTaskCompleted } from '../../../redux/onboarding/actions';
import {useNavigate} from "react-router-dom";
//import './OnboardingPage.scss';

const OnboardingPage: React.FC = () => {
  const dispatch = useDispatch();
  const tasks = useSelector((state: any) => state.onboardingReducer);
  const navigate = useNavigate()

  const handleTaskClick = (task: any) => {
    if(task.link){
        navigate(task.link);
    }
  };

  const calculateProgress = () => {
    const tasksList = ['profileCompleted', 'classroomCreated', 'studentsAdded', 'assignmentsCreated'];
    const completedTasks = tasksList.filter(task => tasks[task]).length;
    return Math.min(Math.round((completedTasks / tasksList.length) * 100), 100);
  };

  const tasksList = [
    {
      id: 'profileCompleted',
      title: 'Profil Bilgilerinizi Tamamlayın',
      completed: tasks.profileCompleted,
    },
    {
      id: 'classroomCreated',
      title: 'Sınıfınızı Oluşturun',
      completed: tasks.classroomCreated,
    },
    {
      id: 'studentsAdded',
      title: 'Öğrencilerinizi Ekleyin',
      description: '(En az 10 öğrenci eklemelisiniz. 30 gün boyunca öğrenci eklenmemiş öğretmen hesapları, güvenlik gereğiyle kapatılır.)',
      completed: tasks.studentsAdded,
      link: '/student/add'
    },
    {
      id: 'assignmentsCreated',
      title: 'Sorumluluk Atayın',
      completed: tasks.assignmentsCreated,
      link: '/homework/create'
    }
  ];

  return (
      <div className="card onboardingStepsWrap">
        <div id="onboardingSteps">
          <div className='onboarding-header'>
            <div className='row align-items-center'>
              <div className='col-lg-6'>
                <h2 className='display-4 mb-3'>Kidly Okul'a Hoşgeldiniz!</h2>
                <p className='lead mb-4'>
                  Okuma ödevleri atamak, quiz sonuçlarına <br/> ulaşmak ve öğrenci raporlarını görmek
                  için <br/> profilinizi
                  tamamlayın.
                </p>
              </div>
              <div className='col-lg-6'>
                {/* Sağ taraftaki görsel */}
              </div>
            </div>
          </div>

          <div className='onboarding-content mt-5'>
            <div className='progress-container mb-4'>
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <h3>Görevler:</h3>
              </div>
              <div className="progress-wrap">
                <div className='progress'>
                  <div
                      className='progress-bar'
                      role='progressbar'
                      style={{width: `${calculateProgress()}%`}}
                      aria-valuenow={calculateProgress()}
                      aria-valuemin={0}
                      aria-valuemax={100}
                  ></div>
                </div>
                <span className='progress-text'>%{calculateProgress()}</span>
              </div>
            </div>

            <div className='tasks-list'>
              {tasksList.map(task => (
                  <div
                      key={task.id}
                      className={`task-item ${task.completed ? 'completed' : ''}`}
                      onClick={() => handleTaskClick(task)}
                  >
                    <div className='task-status'>
                      {task.completed ? (
                          <i className='fas fa-check-circle text-success'></i>
                      ) : (
                          <i className='far fa-circle'></i>
                      )}
                    </div>
                    <div className='task-content'>
                      <h4>{task.title}</h4>
                      {task.description && <p className='text-muted'>{task.description}</p>}
                    </div>
                  </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};

export default OnboardingPage;
